import type { ApiMagentoShippingMethod } from "@jti/magento-types";

export const apiShippingMethodFreeShipping: ApiMagentoShippingMethod = {
  amount: {
    currency: "EUR",
    value: 0,
  },
  available: true,
  disable_for_subscription: false,
  base_amount: null,
  carrier_code: "freeshipping",
  carrier_title: "Free Shipping",
  method_code: "freeshipping",
  method_title: "Free",
  description: null,
};

export const apiShippingMethodRoyalMail: ApiMagentoShippingMethod = {
  amount: {
    currency: "EUR",
    value: 2.99,
  },
  available: true,
  disable_for_subscription: true,
  base_amount: null,
  carrier_code: "tablerate",
  carrier_title: "Tracked",
  method_code: "bestway",
  method_title: "Royal Mail - Tracked - 1 Day Service",
  description: null,
};

export const apiShippingMethodFedex: ApiMagentoShippingMethod = {
  available: true,
  disable_for_subscription: false,
  carrier_code: "fedex",
  carrier_title: "FedEx",
  method_code: "ground",
  method_title: "Ground",
  description: "Delivery in 5-7 business days",
  amount: {
    value: 10,
    currency: "USD",
  },
  base_amount: {
    value: 10,
    currency: "USD",
  },
};

export const apiShippingMethodShipToStore: ApiMagentoShippingMethod = {
  amount: {
    currency: "EUR",
    value: 0,
  },
  available: true,
  disable_for_subscription: true,
  base_amount: null,
  carrier_code: "jti_pickup",
  carrier_title: "Ship to store",
  method_code: "jti_pickup_2",
  method_title: "Method15",
  description: null,
};

export const mockApiShippingMethods = [
  apiShippingMethodFreeShipping,
  apiShippingMethodRoyalMail,
  apiShippingMethodFedex,
  apiShippingMethodShipToStore,
];
